export const DRAWER_WIDTH = 350;
export const DRAWER_WIDTH_TABLET = 180;
export const TABLE_PAGE_INIT = '1';
export const TABLE_PAGE_SIZE = '10';
export const MAX_FILE_SIZE = 5 * 1024 * 1024;
export const LIST_APP_KEY = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];
export const DEFAULT_THRESHOLD = 0.85;
